import { designSystemTheme } from 'ia-react-core';

const appTheme = {
  ...designSystemTheme,
};

export default appTheme;
